import { parseISO } from "date-fns";

import { fetchWorkerShifts } from "../redesign/WorkerShifts/api/usePaginatedWorkerShifts";

interface IsShiftDoubleBookedParams {
  shiftStart: string;
  workerId: string;
  workplaceId: string;
}

export async function isShiftDoubleBooked(params: IsShiftDoubleBookedParams) {
  const { shiftStart, workerId, workplaceId } = params;
  const response = await fetchWorkerShifts({
    workerId,
    workplaceId,
    filter: {
      start: {
        lt: parseISO(shiftStart),
      },
      end: {
        gte: parseISO(shiftStart),
      },
      deleted: false,
    },
  });

  return response.data.length > 0;
}
